<template>
  <div>
  <!-- MAIN -->
  <div class="breadcrumbs ace-save-state" id="breadcrumbs">
    <ul class="breadcrumb">
      <li>
        <a href="#">ダッシュボード</a>
      </li>
    </ul><!-- /.breadcrumb -->
  </div>
  <div class="page-content main-menu">
    <router-link :to="{ name: 'keyadd'}" v-if="isAdmin === 'true'">
      <a class="menu-item">
        <i class="menu-icon glyphicon glyphicon-check menu-icon"></i>
        <span class="menu-name">鍵共有</span>
        <span class="menu-desc">ユーザーに対して一時的な権限付与を行います。</span>
      </a>
    </router-link>
    <router-link :to="{ name: 'user'}" v-if="isAdmin === 'true'">
      <a class="menu-item">
        <i class="menu-icon fa fa-user"></i>
        <span class="menu-name">ユーザー</span>
        <span class="menu-desc">ユーザーの登録・編集<br>を行います。</span>
      </a>
    </router-link>
    <router-link :to="{ name: 'group'}" v-if="isAdmin === 'true'">
      <a class="menu-item">
        <i class="menu-icon fa fa-users"></i>
        <span class="menu-name">ゲートグループ</span>
        <span class="menu-desc">ゲートグループの登録・編集<br>を行います。</span>
      </a>
    </router-link>
    <router-link :to="{ name: 'phones'}" v-if="isAdmin === 'true'">
      <a class="menu-item">
        <i class="menu-icon glyphicon glyphicon-phone"></i>
        <span class="menu-name">スマートフォン</span>
        <span class="menu-desc">スマートフォンの登録・編集<br>を行います。</span>
      </a>
    </router-link>
    <router-link :to="{ name: 'pcode'}" v-if="isAdmin === 'true'">
      <a class="menu-item">
        <i class="menu-icon fa fa-credit-card "></i>
        <span class="menu-name">個人コード</span>
        <span class="menu-desc">NFCカードとテンキー情報の登録・編集を行います。</span>
      </a>
    </router-link>
    <router-link :to="{ name: 'gates'}" v-if="isAdmin === 'true'">
      <a class="menu-item">
        <i class="menu-icon glyphicon glyphicon-log-in"></i>
        <span class="menu-name">ゲート</span>
        <span class="menu-desc">ゲートの登録・編集<br>を行います。</span>
      </a>
    </router-link>
    <router-link :to="{ name: 'logs'}">
      <a class="menu-item">
        <i class="menu-icon glyphicon glyphicon-list"></i>
        <span class="menu-name">ログ情報</span>
        <span class="menu-desc">ログ情報の閲覧・CSV出力<br>を行います。</span>
      </a>
    </router-link>
    <router-link :to="{ name: 'setting'}" v-if="isAdmin === 'true'">
      <a class="menu-item">
        <i class="menu-icon glyphicon glyphicon-cog"></i>
        <span class="menu-name">設定</span>
        <span class="menu-desc">各種情報の設定・編集<br>を行います。</span>
      </a>
    </router-link>
    <router-link :to="{ name: 'export'}" v-if="isAdmin === 'true'">
      <a class="menu-item">
        <i class="menu-icon fa fa-share"></i>
        <span class="menu-name">エクスポート</span>
        <span class="menu-desc">各種項目のCSVファイルへのエクスポートを行います。</span>
      </a>
    </router-link>
  </div>
  <!-- END MAIN -->
  </div>
</template>

<script>
import * as Config from '../../config'

export default {
  name: 'dashboard',
  data () {
    return {
      isAdmin: 'false',
      shareKeyBeValid: 'false'
    }
  },
  created () {
    var vm = this
    vm.getProfile()
  },
  methods: {
    getProfile () {
      this.$http.get(Config.USERS_LIST_API + '?userId=' + encodeURIComponent(localStorage.userProfileId))
        .then(response => {
          console.log(response)
          localStorage.setItem('ownerId', response.body.users[0].owner.ownerId)
          localStorage.setItem('isAdmin', response.body.users[0].isAdmin)
          localStorage.setItem('shareKeyBeValid', response.body.users[0].shareKeyBeValid)
          this.isAdmin = localStorage.isAdmin
          this.shareKeyBeValid = localStorage.shareKeyBeValid
        })
        .catch((error) => {
          if (error.body) {
            this.error = Config.SERVER_CONNECT_ERROR
          } else {
            this.error = Config.SERVER_CONNECT_ERROR
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/dashboard/Index.vue